<template>
  <div id="contenedor-eliminar-presupuesto">
    <v-card v-if="presupuestoEliminar.detalles.length === 0">
      <v-card-title class="secondary--text">Eliminar Presupuesto</v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar este presupuesto?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="$emit('cerrar')"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarPresupuesto"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar">
        </custom-button>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title class="secondary--text">Eliminar Presupuesto</v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¡Primero debe eliminar los detalles de este presupuesto!
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cerrar"
          class="mr-3">
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import mixPresupuestos from './mixPresupuestos';

export default {
  name: 'EliminarPresupuesto',
  mixins: [mixPresupuestos],
  props: {
    presupuestoEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>
